import script from "./OrderCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderCard.vue?vue&type=script&setup=true&lang=js"

import "./OrderCard.vue?vue&type=style&index=0&id=27cf94fe&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27cf94fe"]])

export default __exports__